import React from 'react'
import * as Comp from './input-field.styles'

import type {
  NativeSyntheticEvent,
  TextInput,
  TextInputFocusEventData,
} from 'react-native'
import { useInputTextProps } from '../../hooks'
import type { IInputTextProps } from '../../types'

export const InputTextField = React.forwardRef<TextInput, IInputTextProps>(
  ({ onFocus, ...props }, ref) => {
    const {
      id,
      size,
      inputValue,
      disabled,
      readonly,
      isActive,
      setIsActive,
      onChangeText,
    } = useInputTextProps()

    const handleFocus = (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
      setIsActive(true)
    }

    const handleBlur = (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
      setIsActive(false)
    }

    const isDisabled = disabled || readonly
    const isEditable = !isDisabled || !readonly

    return (
      <Comp.Field
        {...props}
        ref={ref}
        size={size}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChangeText={onChangeText}
        value={inputValue}
        aria-label={id}
        nativeID={id}
        cursorColor="black"
        editable={isDisabled ? false : isEditable}
        disabled={isDisabled}
        readonly={readonly}
        isActive={isActive}
      />
    )
  }
)
